module.exports = __webpack_public_path__ + "static/media/bidStatus.75f2a2dd.png";